import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { httpHeadersInterceptor } from './interceptors/http-headers.interceptor';
import { FooterComponent } from './shared/footer/footer.component';
import { HeaderComponent } from './shared/header/header.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';


import { NgxMaskModule } from 'ngx-mask';

import {
  inject,
  provideAppInitializer,
} from "@angular/core";
import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular";

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    GoogleMapsModule,
    FormsModule,
    NgxMaskModule.forRoot(),
  ],
  exports: [NgxMaskModule],
  providers: [
    {
      
      provide: ErrorHandler, useClass: Sentry.SentryErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [Sentry.TraceService],
      multi: true,
    },
    // provideAppInitializer(() => {
    //   inject(Sentry.TraceService);
    // }),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withInterceptorsFromDi(), withFetch(), withInterceptors([httpHeadersInterceptor])),
    provideAnimationsAsync('noop'),
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(trace: Sentry.TraceService) { }
}
